// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@100;200;300;400;500;600;700;800;900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sectionWrapper_dfCBy {
  display: flex;
  width: 100%;
  flex-direction: column;
  gap: 20px;
}
.infoContainerWrapper_HY1Ha {
  display: flex;
  align-items: center;
  gap: 22px;
  padding: 0;
  justify-content: space-between;
  cursor: pointer;
}
.infoContainer_vGmwb {
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 0;
  padding: 0;
  div {
    color: #1f184b;
    font-size: 12px;
    font-weight: 500;
  }
  span {
    max-width: 360px;
    color: #1f184b;
    font-size: 12px;
    font-weight: 300;
  }
}

.contentContainer_QQMuF {
  &.active_kIgNr {
    display: block;
  }
  &.disabled_jjzss {
    display: none;
  }
}

.contentInput_WaYrR {
  margin-top: 5px;
  display: flex;
  flex-direction: column;
}

.titleContentInput_mRnA1 {
  color: #1f184b;
  font-size: 18px;
  line-height: 1;
  margin-bottom: 8px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .optionsContentInput_QZZtV {
    display: flex;
    align-items: center;
    gap: 10px;
  }
}

.cardTypesContainer_M85LH {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  margin: 9px 0;
}
.singleTypeCard_u07cb {
  display: flex;
  gap: 9px;
  padding: 3px 12px;
  border-radius: 30px;
  border: 1px solid #e0e3e6;
  span {
    font-size: 12px;
    font-weight: 400;
    color: #2a2e32;
    -webkit-user-select: none;
            user-select: none;
  }
}
.minusIcon_QNVUj {
  height: 13px;
  margin-top: 1px;
  width: 13px;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  border-radius: 50%;
  background: #dc3545;
  display: flex;
  align-items: center;
  justify-content: center;
}

.subtitleContentInput_pF0JU {
  font-weight: 300;
  font-size: 11;
  color: #18181b;
}
.quantityContainer__mOjV {
  display: flex;
  gap: 10px;
  align-items: center;

  .quantityContent_xwVFB {
    gap: 10px;
    flex: 1 1;
    display: flex;
    align-items: center;
    box-sizing: border-box;
    color: #1e0045;
    input {
      background-color: var(--f5-background);
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 32px;
      border-radius: 4px;
      padding: 0px 18px;
      font-family: "Inter", sans-serif;
      border: none;
      outline: none;
    }
  }
  p {
    margin: 0;
    height: fit-content;
  }
}
.currencyContainer_khHso {
  color: #264f88;
  font-weight: bold;
  border-bottom: 2px solid #264f88;
  gap: 5px;
  display: flex;
  align-items: center;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  position: relative;
  div {
    gap: 5px;
  }
}

.currencyDropdownButton_VHdHt {
  display: flex;
  gap: 5px;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  position: relative;
}
.chevronIcon_R8lGw {
  margin-top: 3px;
}
.currencyDropdown_rcI8S {
  position: absolute;
  top: 97%;
  left: -4%;
  width: 108%;
  display: flex;
  flex-direction: column;
  background-color: var(--f4-background);
  border-radius: 4px;
  color: #264f88;
  font-size: 14px;
  box-shadow: 0 2px 4px var(--_0000001a-shadow);
  z-index: 1;
  overflow: hidden;

  span {
    display: flex;
    padding: 1px 2px;
    align-items: center;
    cursor: pointer;
    -webkit-user-select: none;
            user-select: none;
    justify-content: flex-start;
    &:hover {
      background-color: var(--ececf1-background);
    }
  }
}

.conditionsContainer_SR2Zp {
  display: flex;
  padding: 5px 9px;
  flex-direction: column;
  justify-content: center;
  align-items: flex-end;
  gap: 10px;
  align-self: stretch;
  border-radius: 5px;
  background: var(--f4-background);
  .conditions_wH47D {
    display: flex;
    width: 100%;
    gap: 10px;
    flex-wrap: wrap;
    .condition_T8P5h {
      display: flex;
      padding: 6px 12px;
      align-items: center;
      gap: 8px;
      border-radius: 30px;
      border: 1px solid #e0e3e6;
      background: var(--white-background);
      -webkit-border-radius: 30px;
      -moz-border-radius: 30px;
      -ms-border-radius: 30px;
      -o-border-radius: 30px;
      color: #2a2e32;
      font-family: Inter;
      font-size: 12px;
      font-style: normal;
      font-weight: 400;
      line-height: 20px;
      overflow: hidden;
      textarea,
      input,
      span {
        font-family: "Inter", sans-serif;
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        line-height: 20px;
        overflow: hidden;
        border: none;
        padding: 0;
      }
    }
    .conditionInput_OdcdJ {
      outline: none;
      border: none;
      resize: none;
    }
  }
  input {
    background-color: transparent;
    border: none;
    outline: none;
    font-family: Inter;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 21px; 
    box-sizing: border-box;
    &::placeholder {
      color: var(--_71717a-color);
      font-family: Inter;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 21px; 
    }
  }
}

.labelName_wT3CV input {
  display: flex;
  height: 32px;
  padding: 6px 8px;
  justify-content: space-between;
  align-items: center;
  flex: 1 0;
  border-radius: 4px;
  outline: none;
  border: none;
  color: #000000;
  font-size: 14px;
  font-weight: 400;

  &::placeholder {
    color: #000000;
  }
}
.labelName_wT3CV input:not([disabled]) {
  background-color: var(--f4-background);
  border-radius: 5px;
  box-sizing: border-box;
  width: 100%;
  padding: 12px;
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  -ms-border-radius: 5px;
  -o-border-radius: 5px;
}
.filtersLabelOptions_KxGe3 {
  border-left: 1px solid #c3c3c3;
  display: flex;
  padding-left: 22px;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  align-self: stretch;
  p {
    margin: 5px;
  }
}

.changeTypeContainerButton_sFyck {
  display: flex;
  width: 100%;
  display: flex;
  height: 50px;
  padding: 6px 5px;
  align-items: center;
  gap: 10px;
  align-self: stretch;
  border-radius: 12px;
  background: var(--f9-background);
  > button {
    display: flex;  
    justify-content: center;
    align-items: center;
    gap: 10px;
    flex: 1 0;
    border-radius: 8px;
    box-shadow:
      0px 0px 2px 0px rgba(0, 0, 0, 0.03),
      0px 0px 0px 0px rgba(0, 0, 0, 0),
      0px 0px 0px 0px rgba(0, 0, 0, 0);
    background-color: transparent;
    outline: none;
    border: 1px solid transparent;
    color: var(--_b4-color);
    font-family: Inter;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px; 
  }
  .typeFilterBtn_G_MO9 {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 10px;
    flex: 1 0;
    border-radius: 8px;
    border: 1px solid var(--_0000001a-shadow);
    background: #fff;
    box-shadow:
      0px 0px 2px 0px rgba(0, 0, 0, 0.03),
      0px 0px 0px 0px rgba(0, 0, 0, 0),
      0px 0px 0px 0px rgba(0, 0, 0, 0);
    color: #0d0d0d;
  }
}
.buttonAddFilter_KfnjH {
  display: flex;
  height: fit-content;
  padding: 14px 24px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 8px;
  border: 1px solid #cbcbcb;
  background: #fff;
  cursor: pointer;
  flex: 1 1;
  box-sizing: border-box;
  width: 100%;
}

.keywordContainer_O_0Uu {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  margin: 9px 0;
  .keyword_PmO53 {
    display: flex;
    gap: 9px;
    padding: 3px 12px;
    border-radius: 30px;
    border: 1px solid #e0e3e6;
    align-items: center;
  }
}




.headerLeft_EP_u3 {
  display: flex;
  align-items: flex-start;
  gap: 12px;
}

.searchIcon_GwM7s {
  margin-top: 4px;
  color: #10b981;
}

.headerText_N5tSV {
  display: flex;
  flex-direction: column;
}

.title_GJi7R {
  color: #1f2937;
  font-weight: 500;
  font-size: 16px;
  margin: 0;
}

.description_ekEQj {
  color: var(--6b7280-color);
  font-size: 14px;
  margin: 4px 0 0 0;
}






.formLabel_Z6d9L {
  color: var(--_1f184b-color);
  font-size: 13px;
  line-height: 1;
  border-bottom: 0px solid var(--e8-border);
  border-top: 0px solid var(--e8-border);
  margin-top: 0px;
  margin-bottom: 0px;
  margin-bottom: 6px;
}

.selectContainer_A217F {
  position: relative;
}

.selectInput_MS1T7 {
  appearance: none;
  width: 100%;
  background-color: var(--f9fafb-background);
  border: 1px solid #e5e7eb;
  color: #4b5563;
  border-radius: 4px;
  font-size: 14px;
  height: 31px;
}

.selectInput_MS1T7:focus {
  outline: none;
  background-color: var(--white-color);
  border-color: #d1d5db;
}



.carouselContainer_vSDPO {
  display: flex;
  gap: 10px;
  padding: 0px;
  overflow-x: hidden;
  max-width: 385px;
}



.selectedVariablesContainer_iR2Ft {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin: 10px 0;

  .selectedVariables_NvUWc {
    display: flex;
    gap: 9px;
    padding: 3px 12px;
    border-radius: 30px;
    border: 1px solid #e0e3e6;
    align-items: center;
    width: fit-content;
  }
}
`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/components/SaveProcessDocument/SaveProcessDocument.module.css"],"names":[],"mappings":"AAEA;EACE,aAAa;EACb,WAAW;EACX,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,UAAU;EACV,8BAA8B;EAC9B,eAAe;AACjB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,MAAM;EACN,UAAU;EACV;IACE,cAAc;IACd,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,cAAc;EAChB;EACA;IACE,aAAa;EACf;AACF;;AAEA;EACE,eAAe;EACf,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;EACX;AACF;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,aAAa;AACf;AACA;EACE,aAAa;EACb,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB;IACE,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,yBAAiB;YAAjB,iBAAiB;EACnB;AACF;AACA;EACE,YAAY;EACZ,eAAe;EACf,WAAW;EACX,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,cAAc;AAChB;AACA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;;EAEnB;IACE,SAAS;IACT,SAAO;IACP,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,cAAc;IACd;MACE,sCAAsC;MACtC,aAAa;MACb,mBAAmB;MACnB,8BAA8B;MAC9B,YAAY;MACZ,kBAAkB;MAClB,iBAAiB;MACjB,gCAAgC;MAChC,YAAY;MACZ,aAAa;IACf;EACF;EACA;IACE,SAAS;IACT,mBAAmB;EACrB;AACF;AACA;EACE,cAAc;EACd,iBAAiB;EACjB,gCAAgC;EAChC,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,kBAAkB;EAClB;IACE,QAAQ;EACV;AACF;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,sCAAsC;EACtC,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,6CAA6C;EAC7C,UAAU;EACV,gBAAgB;;EAEhB;IACE,aAAa;IACb,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;IACf,yBAAiB;YAAjB,iBAAiB;IACjB,2BAA2B;IAC3B;MACE,0CAA0C;IAC5C;EACF;AACF;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,sBAAsB;EACtB,uBAAuB;EACvB,qBAAqB;EACrB,SAAS;EACT,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;EAChC;IACE,aAAa;IACb,WAAW;IACX,SAAS;IACT,eAAe;IACf;MACE,aAAa;MACb,iBAAiB;MACjB,mBAAmB;MACnB,QAAQ;MACR,mBAAmB;MACnB,yBAAyB;MACzB,mCAAmC;MACnC,2BAA2B;MAC3B,wBAAwB;MACxB,uBAAuB;MACvB,sBAAsB;MACtB,cAAc;MACd,kBAAkB;MAClB,eAAe;MACf,kBAAkB;MAClB,gBAAgB;MAChB,iBAAiB;MACjB,gBAAgB;MAChB;;;QAGE,gCAAgC;QAChC,eAAe;QACf,kBAAkB;QAClB,gBAAgB;QAChB,iBAAiB;QACjB,gBAAgB;QAChB,YAAY;QACZ,UAAU;MACZ;IACF;IACA;MACE,aAAa;MACb,YAAY;MACZ,YAAY;IACd;EACF;EACA;IACE,6BAA6B;IAC7B,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,sBAAsB;IACtB;MACE,2BAA2B;MAC3B,kBAAkB;MAClB,eAAe;MACf,kBAAkB;MAClB,gBAAgB;MAChB,iBAAiB;IACnB;EACF;AACF;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,8BAA8B;EAC9B,mBAAmB;EACnB,SAAW;EACX,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,cAAc;EACd,eAAe;EACf,gBAAgB;;EAEhB;IACE,cAAc;EAChB;AACF;AACA;EACE,sCAAsC;EACtC,kBAAkB;EAClB,sBAAsB;EACtB,WAAW;EACX,aAAa;EACb,0BAA0B;EAC1B,uBAAuB;EACvB,sBAAsB;EACtB,qBAAqB;AACvB;AACA;EACE,8BAA8B;EAC9B,aAAa;EACb,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB;IACE,WAAW;EACb;AACF;;AAEA;EACE,aAAa;EACb,WAAW;EACX,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,mBAAmB;EACnB,gCAAgC;EAChC;IACE,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;IACT,SAAW;IACX,kBAAkB;IAClB;;;sCAGkC;IAClC,6BAA6B;IAC7B,aAAa;IACb,6BAA6B;IAC7B,uBAAuB;IACvB,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;EACnB;EACA;IACE,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;IACT,SAAW;IACX,kBAAkB;IAClB,yCAAyC;IACzC,gBAAgB;IAChB;;;sCAGkC;IAClC,cAAc;EAChB;AACF;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf,SAAO;EACP,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,aAAa;EACb;IACE,aAAa;IACb,QAAQ;IACR,iBAAiB;IACjB,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;EACrB;AACF;;;;;AAKA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,0BAA0B;EAC1B,eAAe;EACf,iBAAiB;AACnB;;;;;;;AAOA;EACE,2BAA2B;EAC3B,eAAe;EACf,cAAc;EACd,yCAAyC;EACzC,sCAAsC;EACtC,eAAe;EACf,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,0CAA0C;EAC1C,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,aAAa;EACb,oCAAoC;EACpC,qBAAqB;AACvB;;;;AAIA;EACE,aAAa;EACb,SAAS;EACT,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;AAClB;;;;AAIA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,cAAc;;EAEd;IACE,aAAa;IACb,QAAQ;IACR,iBAAiB;IACjB,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;EACpB;AACF","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Inter:wght@100;200;300;400;500;600;700;800;900&display=swap\");\n\n.sectionWrapper {\n  display: flex;\n  width: 100%;\n  flex-direction: column;\n  gap: 20px;\n}\n.infoContainerWrapper {\n  display: flex;\n  align-items: center;\n  gap: 22px;\n  padding: 0;\n  justify-content: space-between;\n  cursor: pointer;\n}\n.infoContainer {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  gap: 0;\n  padding: 0;\n  div {\n    color: #1f184b;\n    font-size: 12px;\n    font-weight: 500;\n  }\n  span {\n    max-width: 360px;\n    color: #1f184b;\n    font-size: 12px;\n    font-weight: 300;\n  }\n}\n\n.contentContainer {\n  &.active {\n    display: block;\n  }\n  &.disabled {\n    display: none;\n  }\n}\n\n.contentInput {\n  margin-top: 5px;\n  display: flex;\n  flex-direction: column;\n}\n\n.titleContentInput {\n  color: #1f184b;\n  font-size: 18px;\n  line-height: 1;\n  margin-bottom: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  .optionsContentInput {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n  }\n}\n\n.cardTypesContainer {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 4px;\n  margin: 9px 0;\n}\n.singleTypeCard {\n  display: flex;\n  gap: 9px;\n  padding: 3px 12px;\n  border-radius: 30px;\n  border: 1px solid #e0e3e6;\n  span {\n    font-size: 12px;\n    font-weight: 400;\n    color: #2a2e32;\n    user-select: none;\n  }\n}\n.minusIcon {\n  height: 13px;\n  margin-top: 1px;\n  width: 13px;\n  cursor: pointer;\n  user-select: none;\n  border-radius: 50%;\n  background: #dc3545;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.subtitleContentInput {\n  font-weight: 300;\n  font-size: 11;\n  color: #18181b;\n}\n.quantityContainer {\n  display: flex;\n  gap: 10px;\n  align-items: center;\n\n  .quantityContent {\n    gap: 10px;\n    flex: 1;\n    display: flex;\n    align-items: center;\n    box-sizing: border-box;\n    color: #1e0045;\n    input {\n      background-color: var(--f5-background);\n      display: flex;\n      align-items: center;\n      justify-content: space-between;\n      height: 32px;\n      border-radius: 4px;\n      padding: 0px 18px;\n      font-family: \"Inter\", sans-serif;\n      border: none;\n      outline: none;\n    }\n  }\n  p {\n    margin: 0;\n    height: fit-content;\n  }\n}\n.currencyContainer {\n  color: #264f88;\n  font-weight: bold;\n  border-bottom: 2px solid #264f88;\n  gap: 5px;\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  user-select: none;\n  position: relative;\n  div {\n    gap: 5px;\n  }\n}\n\n.currencyDropdownButton {\n  display: flex;\n  gap: 5px;\n  cursor: pointer;\n  user-select: none;\n  position: relative;\n}\n.chevronIcon {\n  margin-top: 3px;\n}\n.currencyDropdown {\n  position: absolute;\n  top: 97%;\n  left: -4%;\n  width: 108%;\n  display: flex;\n  flex-direction: column;\n  background-color: var(--f4-background);\n  border-radius: 4px;\n  color: #264f88;\n  font-size: 14px;\n  box-shadow: 0 2px 4px var(--_0000001a-shadow);\n  z-index: 1;\n  overflow: hidden;\n\n  span {\n    display: flex;\n    padding: 1px 2px;\n    align-items: center;\n    cursor: pointer;\n    user-select: none;\n    justify-content: flex-start;\n    &:hover {\n      background-color: var(--ececf1-background);\n    }\n  }\n}\n\n.conditionsContainer {\n  display: flex;\n  padding: 5px 9px;\n  flex-direction: column;\n  justify-content: center;\n  align-items: flex-end;\n  gap: 10px;\n  align-self: stretch;\n  border-radius: 5px;\n  background: var(--f4-background);\n  .conditions {\n    display: flex;\n    width: 100%;\n    gap: 10px;\n    flex-wrap: wrap;\n    .condition {\n      display: flex;\n      padding: 6px 12px;\n      align-items: center;\n      gap: 8px;\n      border-radius: 30px;\n      border: 1px solid #e0e3e6;\n      background: var(--white-background);\n      -webkit-border-radius: 30px;\n      -moz-border-radius: 30px;\n      -ms-border-radius: 30px;\n      -o-border-radius: 30px;\n      color: #2a2e32;\n      font-family: Inter;\n      font-size: 12px;\n      font-style: normal;\n      font-weight: 400;\n      line-height: 20px;\n      overflow: hidden;\n      textarea,\n      input,\n      span {\n        font-family: \"Inter\", sans-serif;\n        font-size: 12px;\n        font-style: normal;\n        font-weight: 400;\n        line-height: 20px;\n        overflow: hidden;\n        border: none;\n        padding: 0;\n      }\n    }\n    .conditionInput {\n      outline: none;\n      border: none;\n      resize: none;\n    }\n  }\n  input {\n    background-color: transparent;\n    border: none;\n    outline: none;\n    font-family: Inter;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 21px; \n    box-sizing: border-box;\n    &::placeholder {\n      color: var(--_71717a-color);\n      font-family: Inter;\n      font-size: 14px;\n      font-style: normal;\n      font-weight: 400;\n      line-height: 21px; \n    }\n  }\n}\n\n.labelName input {\n  display: flex;\n  height: 32px;\n  padding: 6px 8px;\n  justify-content: space-between;\n  align-items: center;\n  flex: 1 0 0;\n  border-radius: 4px;\n  outline: none;\n  border: none;\n  color: #000000;\n  font-size: 14px;\n  font-weight: 400;\n\n  &::placeholder {\n    color: #000000;\n  }\n}\n.labelName input:not([disabled]) {\n  background-color: var(--f4-background);\n  border-radius: 5px;\n  box-sizing: border-box;\n  width: 100%;\n  padding: 12px;\n  -webkit-border-radius: 5px;\n  -moz-border-radius: 5px;\n  -ms-border-radius: 5px;\n  -o-border-radius: 5px;\n}\n.filtersLabelOptions {\n  border-left: 1px solid #c3c3c3;\n  display: flex;\n  padding-left: 22px;\n  flex-direction: column;\n  align-items: center;\n  gap: 10px;\n  align-self: stretch;\n  p {\n    margin: 5px;\n  }\n}\n\n.changeTypeContainerButton {\n  display: flex;\n  width: 100%;\n  display: flex;\n  height: 50px;\n  padding: 6px 5px;\n  align-items: center;\n  gap: 10px;\n  align-self: stretch;\n  border-radius: 12px;\n  background: var(--f9-background);\n  > button {\n    display: flex;  \n    justify-content: center;\n    align-items: center;\n    gap: 10px;\n    flex: 1 0 0;\n    border-radius: 8px;\n    box-shadow:\n      0px 0px 2px 0px rgba(0, 0, 0, 0.03),\n      0px 0px 0px 0px rgba(0, 0, 0, 0),\n      0px 0px 0px 0px rgba(0, 0, 0, 0);\n    background-color: transparent;\n    outline: none;\n    border: 1px solid transparent;\n    color: var(--_b4-color);\n    font-family: Inter;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 24px; \n  }\n  .typeFilterBtn {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    gap: 10px;\n    flex: 1 0 0;\n    border-radius: 8px;\n    border: 1px solid var(--_0000001a-shadow);\n    background: #fff;\n    box-shadow:\n      0px 0px 2px 0px rgba(0, 0, 0, 0.03),\n      0px 0px 0px 0px rgba(0, 0, 0, 0),\n      0px 0px 0px 0px rgba(0, 0, 0, 0);\n    color: #0d0d0d;\n  }\n}\n.buttonAddFilter {\n  display: flex;\n  height: fit-content;\n  padding: 14px 24px;\n  justify-content: center;\n  align-items: center;\n  gap: 10px;\n  border-radius: 8px;\n  border: 1px solid #cbcbcb;\n  background: #fff;\n  cursor: pointer;\n  flex: 1;\n  box-sizing: border-box;\n  width: 100%;\n}\n\n.keywordContainer {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 4px;\n  margin: 9px 0;\n  .keyword {\n    display: flex;\n    gap: 9px;\n    padding: 3px 12px;\n    border-radius: 30px;\n    border: 1px solid #e0e3e6;\n    align-items: center;\n  }\n}\n\n\n\n\n.headerLeft {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n}\n\n.searchIcon {\n  margin-top: 4px;\n  color: #10b981;\n}\n\n.headerText {\n  display: flex;\n  flex-direction: column;\n}\n\n.title {\n  color: #1f2937;\n  font-weight: 500;\n  font-size: 16px;\n  margin: 0;\n}\n\n.description {\n  color: var(--6b7280-color);\n  font-size: 14px;\n  margin: 4px 0 0 0;\n}\n\n\n\n\n\n\n.formLabel {\n  color: var(--_1f184b-color);\n  font-size: 13px;\n  line-height: 1;\n  border-bottom: 0px solid var(--e8-border);\n  border-top: 0px solid var(--e8-border);\n  margin-top: 0px;\n  margin-bottom: 0px;\n  margin-bottom: 6px;\n}\n\n.selectContainer {\n  position: relative;\n}\n\n.selectInput {\n  appearance: none;\n  width: 100%;\n  background-color: var(--f9fafb-background);\n  border: 1px solid #e5e7eb;\n  color: #4b5563;\n  border-radius: 4px;\n  font-size: 14px;\n  height: 31px;\n}\n\n.selectInput:focus {\n  outline: none;\n  background-color: var(--white-color);\n  border-color: #d1d5db;\n}\n\n\n\n.carouselContainer {\n  display: flex;\n  gap: 10px;\n  padding: 0px;\n  overflow-x: hidden;\n  max-width: 385px;\n}\n\n\n\n.selectedVariablesContainer {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n  margin: 10px 0;\n\n  .selectedVariables {\n    display: flex;\n    gap: 9px;\n    padding: 3px 12px;\n    border-radius: 30px;\n    border: 1px solid #e0e3e6;\n    align-items: center;\n    width: fit-content;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"sectionWrapper": `sectionWrapper_dfCBy`,
	"infoContainerWrapper": `infoContainerWrapper_HY1Ha`,
	"infoContainer": `infoContainer_vGmwb`,
	"contentContainer": `contentContainer_QQMuF`,
	"active": `active_kIgNr`,
	"disabled": `disabled_jjzss`,
	"contentInput": `contentInput_WaYrR`,
	"titleContentInput": `titleContentInput_mRnA1`,
	"optionsContentInput": `optionsContentInput_QZZtV`,
	"cardTypesContainer": `cardTypesContainer_M85LH`,
	"singleTypeCard": `singleTypeCard_u07cb`,
	"minusIcon": `minusIcon_QNVUj`,
	"subtitleContentInput": `subtitleContentInput_pF0JU`,
	"quantityContainer": `quantityContainer__mOjV`,
	"quantityContent": `quantityContent_xwVFB`,
	"currencyContainer": `currencyContainer_khHso`,
	"currencyDropdownButton": `currencyDropdownButton_VHdHt`,
	"chevronIcon": `chevronIcon_R8lGw`,
	"currencyDropdown": `currencyDropdown_rcI8S`,
	"conditionsContainer": `conditionsContainer_SR2Zp`,
	"conditions": `conditions_wH47D`,
	"condition": `condition_T8P5h`,
	"conditionInput": `conditionInput_OdcdJ`,
	"labelName": `labelName_wT3CV`,
	"filtersLabelOptions": `filtersLabelOptions_KxGe3`,
	"changeTypeContainerButton": `changeTypeContainerButton_sFyck`,
	"typeFilterBtn": `typeFilterBtn_G_MO9`,
	"buttonAddFilter": `buttonAddFilter_KfnjH`,
	"keywordContainer": `keywordContainer_O_0Uu`,
	"keyword": `keyword_PmO53`,
	"headerLeft": `headerLeft_EP_u3`,
	"searchIcon": `searchIcon_GwM7s`,
	"headerText": `headerText_N5tSV`,
	"title": `title_GJi7R`,
	"description": `description_ekEQj`,
	"formLabel": `formLabel_Z6d9L`,
	"selectContainer": `selectContainer_A217F`,
	"selectInput": `selectInput_MS1T7`,
	"carouselContainer": `carouselContainer_vSDPO`,
	"selectedVariablesContainer": `selectedVariablesContainer_iR2Ft`,
	"selectedVariables": `selectedVariables_NvUWc`
};
export default ___CSS_LOADER_EXPORT___;
